import {ActionButton, IconButton, Stack, Text} from "@fluentui/react";
import React, {FC, useMemo} from "react";
import {useTranslation} from "react-i18next";
import {PagedResult} from "../API";

interface ITenantPagination {
    nextPage: () => void;
    paginate?: boolean;
    paging: { page: number; count: number };
    previousPage: () => void;
    result?: PagedResult<any>;
    compact?: boolean;
    showAll?: () => void;
    disabled?: boolean;
}

export const TenantPagination: FC<ITenantPagination> = ({
                                                            paginate,
                                                            showAll,
                                                            paging,
                                                            compact,
                                                            previousPage,
                                                            result,
                                                            nextPage,
                                                            disabled,
                                                        }) => {
    const {t} = useTranslation();

    compact = compact != false;

    const fontColor = useMemo(
        () => (disabled ? "rgb(200, 198, 196)" : undefined),
        [disabled],
    );

    return paginate ? (
        <Stack
            horizontal
            verticalAlign={"center"}
            style={{padding: 0, margin: 0, color: `${fontColor} !important`}}
            tokens={{childrenGap: 10}}
            maxHeight={32}
        >
            {showAll ? (
                <ActionButton
                    disabled={disabled}
                    onClick={paging.page == -1 ? nextPage : showAll}
                    iconProps={{
                        iconName: paging.page == -1 ? "reopenPages" : "favicon",
                    }}
                    text={t(paging.page == -1 ? "show-paginated" : "show-all-items")}
                    title={t(paging.page == -1 ? "show-paginated" : "show-all-items")}
                />
            ) : null}
            {paging.page == -1 ? (
                <></>
            ) : result?.totalPages != undefined && result.totalPages != 0 ? (
                <>
                    <IconButton
                        iconProps={{iconName: "ChevronLeft"}}
                        disabled={disabled || paging.page <= 0}
                        onClick={previousPage}
                    >
                        {compact ? null : t("previous")}
                    </IconButton>
                    <Text color={fontColor}>
                        {compact ? null : (
                            <span style={{color: fontColor}}>{t("page") + " "}</span>
                        )}
                        <span style={{color: fontColor}}>{paging.page + 1}</span>
                        {result != undefined ? (
                            <>
                <span style={{color: fontColor}}>
                  {" " + t("paging-of") + " "}
                </span>
                                <b style={{color: fontColor}}>{result?.totalPages || 1}</b>
                            </>
                        ) : (
                            ""
                        )}
                    </Text>
                    <IconButton
                        iconProps={{iconName: "ChevronRight"}}
                        onClick={nextPage}
                        disabled={disabled || result?.lastPage}
                    >
                        {compact ? null : t("next-one")}
                    </IconButton>
                </>
            ) : (
                <></>
            )}
        </Stack>
    ) : null;
};
